import { render } from "./CardDistrictOffice.vue?vue&type=template&id=3946ef0e&ts=true"
import script from "./CardDistrictOffice.vue?vue&type=script&lang=ts"
export * from "./CardDistrictOffice.vue?vue&type=script&lang=ts"

import "./CardDistrictOffice.vue?vue&type=style&index=0&id=3946ef0e&lang=scss"

import exportComponent from "C:\\Arbeit\\wordpress_projekte\\castroper-klimahelden\\wp-content\\themes\\cas-klimahelden-theme\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__